import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Container,
  IconButton,
  Drawer,
  Box,
  List,
  ListItemButton,
  ListItemText,
  Tooltip,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ExtensionIcon from '@mui/icons-material/Extension';
import { Link, useNavigate } from 'react-router-dom';
import useIsMobile from '../hooks/useIsMobile';

// Liens de navigation, partagés entre le rendu desktop (boutons) et le rendu
// mobile (drawer). Ordre et libellés identiques à l'existant.
// « Extension Chrome » est une icône sur desktop (pièce de puzzle, comme dans
// Chrome) : un 12e libellé ferait passer la barre sur deux lignes sous 1 536 px.
const NAV_LINKS: { to: string; label: string; icone?: React.ReactElement }[] = [
  { to: '/tdb', label: 'Tableau de Bord' },
  { to: '/demandes', label: 'Demandes' },
  { to: '/facturation', label: 'Facturation' },
  { to: '/pays', label: 'Pays' },
  { to: '/visas', label: 'Visas' },
  { to: '/utilisateurs', label: 'Clients' },
  { to: '/societes', label: 'Sociétés' },
  { to: '/mails', label: 'Mails' },
  { to: '/alertes', label: 'Alertes' },
  { to: '/formulaires', label: 'Formulaires' },
  { to: '/pieces-jointes', label: 'Pièces jointes' },
  { to: '/extension-chrome', label: 'Extension Chrome', icone: <ExtensionIcon /> },
];

function Home() {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const goTo = (to: string) => {
    setDrawerOpen(false);
    navigate(to);
  };

  return (
    <AppBar position="static" color="primary">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {isMobile ? (
            // --- Rendu mobile : hamburger + Drawer ---
            <>
              <IconButton
                color="inherit"
                edge="start"
                aria-label="ouvrir le menu"
                onClick={() => setDrawerOpen(true)}
                sx={{ mr: 1 }}
              >
                <MenuIcon />
              </IconButton>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }} noWrap>
                Admin Visa Monde
              </Typography>

              <Drawer anchor="left" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
                <Box sx={{ width: 250 }} role="presentation">
                  <Box sx={{ px: 2, py: 2 }}>
                    <Typography variant="subtitle1" fontWeight="bold">
                      Admin Visa Monde
                    </Typography>
                  </Box>
                  <List>
                    {NAV_LINKS.map((link) => (
                      <ListItemButton key={link.to} onClick={() => goTo(link.to)}>
                        <ListItemText primary={link.label} />
                      </ListItemButton>
                    ))}
                  </List>
                </Box>
              </Drawer>
            </>
          ) : (
            // --- Rendu desktop : identique à l'existant ---
            <>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                Admin Visa Monde
              </Typography>
              {NAV_LINKS.map((link) => (link.icone ? (
                <Tooltip key={link.to} title={link.label}>
                  <IconButton component={Link} to={link.to} aria-label={link.label} sx={{ color: '#fff' }}>
                    {link.icone}
                  </IconButton>
                </Tooltip>
              ) : (
                <Button
                  key={link.to}
                  color="inherit"
                  component={Link}
                  to={link.to}
                  sx={{ color: '#fff' }}
                >
                  {link.label}
                </Button>
              )))}
            </>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default Home;
